<template>
    <v-col cols="12">
        <v-row class="my-4">
            <span class="text-normal">{{ formatMenuText($t('account.passwordManager')) }}</span>
        </v-row>
        <v-row class="mb-2">
            <v-text-field id="fActualPass"
                          v-model="value.OldPassword"
                          :label="formatMenuText($t('account.currentPassword'))"
                          class="text-normal"
                          outlined hide-details
                          maxlength="30"
                          :type="oldPasswordVisible ? 'text' : 'password'"
                          :readonly="waitHack"
                          :rules="disabled? [] : requiredRules"
                          @change="$emit('changed')"
                          :disabled="disabled"
                          :append-icon="oldPasswordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                          @click:append="oldPasswordVisible = !oldPasswordVisible"
                          @keydown.enter.prevent="$refs['newPassword'].focus()"/>
        </v-row>
        <v-row class="mb-2">
            <v-text-field id="fNewPass"
                          ref="newPassword"
                          v-model="value.NewPassword"
                          :label="formatMenuText($t('account.newPassword'))"
                          class="text-normal"
                          outlined hide-details
                          maxlength="30"
                          :type="newPasswordVisible ? 'text' : 'password'"
                          :rules="disabled? [] : passwordRules"
                          autocomplete="new-password" 
                          :disabled="disabled"
                          @change="$emit('changed')"
                          :append-icon="newPasswordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                          @click:append="newPasswordVisible = !newPasswordVisible"
                          @keydown.enter.prevent="$refs['passConfirmation'].focus()"/>
        </v-row>
        <v-row class="mb-2">
            <v-text-field id="fPassConf"
                          ref="passConfirmation"
                          v-model="value.ConfPassword"
                          :label="formatMenuText($t('account.passwordConfirmation'))"
                          class="text-normal"
                          outlined hide-details
                          maxlength="30"
                          :type="confirmationPasswordVisible ? 'text' : 'password'"
                          :rules="disabled? [] : passwordConfirmationRules"
                          :disabled="disabled"
                          autocomplete="new-password" 
                          @change="$emit('changed')"
                          :append-icon="confirmationPasswordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                          @click:append="confirmationPasswordVisible = !confirmationPasswordVisible"/>
        </v-row>
        <v-row style="font-size:15px; margin-bottom:20px; text-align:left; color:#595959;">
            <div v-html="$t('account.passwordRules')"></div>
        </v-row>
    </v-col>
</template>
<script>
    export default {
        name: 'password-manager',
        props: [ 'value', 'disabled' ],
        data: function () {
            return {
                waitHack: true,
                passwordRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v && v.length >= 8 && v.length <= 30) || ''
                ],
                passwordConfirmationRules: [
                    v => !!v || this.$t('requiredField'),
                    v => (v === this.value.NewPassword) || ''
                ],
                requiredRules: [
                    v => !!v || this.$t('requiredField')
                ],
                confirmationPasswordVisible: false,
                oldPasswordVisible: false,
                newPasswordVisible: false,
            };
        },
        created() {
            // Hack pour empêcher le browser d'autocomplete les fields.
            setTimeout(() => {
                this.waitHack = false;
            }, 3000);

        },
        methods: {
            formatMenuText(text) {
                if (!text) return text;

                // Check the titleCase setting from the current experience
                const titleCase = this.$experience.titleCase !== false; // default to true if not set

                if (titleCase) {
                    // Title case: capitalize first letter of all words
                    return text.split(' ').map(word => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        return word.charAt(0).toUpperCase() + word.slice(1);
                    }).join(' ');
                } else {
                    // Sentence case: only capitalize first letter of first word
                    // But preserve acronyms
                    const words = text.split(' ');
                    return words.map((word, index) => {
                        if (word.length === 0) return word;
                        // Check if word is an acronym (all uppercase)
                        if (word === word.toUpperCase() && word.length > 1) {
                            return word; // Keep acronyms as-is
                        }
                        if (index === 0) {
                            // First word: capitalize first letter
                            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                        } else {
                            // Other words: all lowercase
                            return word.toLowerCase();
                        }
                    }).join(' ');
                }
            },
            textLengthRule(fieldName, n) {
                return this.$t('textLengthRule', { field: this.$t(fieldName), n: n })
            }
        }
    };
</script>